
import { Options, Vue } from 'vue-class-component';
import MainLayout from '@/layouts/MainLayout/MainLayout.vue';
import LogoMain from '@/components/LogoMain/LogoMain.vue';
import Loading from '@/components/Loading/Loading.vue';

import BusEvent from "../../../../shared/js/BusEvent";
import { DataStore, EventStore, LocaleStore } from '@/store';


const LogoOnf = require("@/assets/logos/logo-onf.png");
const LogoCC = require("@/assets/logos/logo-combatant-canada.png");
const LogoVF = require("@/assets/logos/logo-vimy-fondation.png");

export interface ISplashPagePartner {
    url?: string;
    logo: string;
    title: string;
}

@Options({
  components: {
      MainLayout,
      LogoMain,
    Loading
  },
  prop: {
      //partners: Object as PropType<ISplashPagePartner>,
  }
})
export default class HomePage extends Vue {
    declare $refs: {
        loading: any;
        logo: HTMLImageElement;
    };


    dataFailed: boolean = false;
    dataLoading: boolean = false;
    dataLoaded: boolean = false;
    localeLoading: boolean = false;
    localeLoaded: boolean = false;
    ready: boolean = false;
    dataError: boolean = false;
    localeError: boolean = false;
    dataUnwatch!: Function;
    localeUnwatch!: Function;
    readyUnwatch!: Function;
    completeLoading: boolean = false;
    finalizeLoadingAnimation: boolean = false;
    finalizingLoadingFrameEnd: number = 72;
    hasLogoAnimationPlayed: boolean = false;

    get loading(): boolean
    {

        return (this.dataLoading || this.localeLoading || !this.ready);
    }

    get error(): boolean {
        return (this.dataError || this.localeError);
    }

    get showError() {
        if (this.loading)
            return false;

        return this.error;
    }

 // @TODO - Si dynamique, permettre d'avoir une class larger pour les logos plus large comme le Canada
  partners: ISplashPagePartner[] = [
      {
          logo: LogoVF,
          title: "La fondation VIMY - The VIMY Foundation",
      },
      {
          logo: LogoCC,
          title: "Financé par Anciens Combattants Canada - Funded by Veterans Affairs Canada",
      },
      {
          logo: LogoOnf,
          title: "ONF - NFB",
      }
  ];

  setLocale(lang: string) : void
  {
    this.$i18n.locale = lang;

    //Added By MT
    const eventLang = new BusEvent(BusEvent.EVENTS.LANG, {lang});
    document.dispatchEvent(eventLang);

    const eventUI = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {key: "VM_D_1_", loop: false, group: "UI"});
    document.dispatchEvent(eventUI);

    const eventAmbiance = new BusEvent(BusEvent.EVENTS.PLAY_SOUND, {key: "VM_N_", loop: true, group: "AMBIANCE"});
    document.dispatchEvent(eventAmbiance);

  }

  mounted() {
    this.$watch('loading', (value: boolean, legacy: boolean) =>
    {
         //console.log('loading has changed', value, legacy);
        if (!value)
        {
          this.completeLoading = true;
          this.hasLogoAnimationPlayed = true;
          this.$refs.loading.startLoadingComplete();

        }
    });



    this.dataLoading = DataStore.isFetching;
    this.localeLoading = LocaleStore.isFetching;

    // ignore this boolean in the template if loading hasn't finish
    this.dataError = DataStore.didFetchFailed ?? true;
    this.localeError = LocaleStore.didFetchFailed ?? true;


    this.localeUnwatch = LocaleStore.$watch(t => t.isFetching, (value, _) => {
          this.localeLoading = value;
          if (value) return;

          this.localeError = LocaleStore.didFetchFailed ?? true;
          this.localeLoaded = true;
          this.check();
        });

    DataStore.$watch(t => t.didFetchFailed, (value, oldvalue) => {
      if (value === true)
        this.dataFailed = true;
    });

    this.dataUnwatch = DataStore.$watch(
      (t) => t.isFetching,
      (value, _) => {
        this.dataLoading = value;
        if (value) return;

        this.dataError = DataStore.didFetchFailed ?? true;
        this.dataLoaded = true;
        this.check();
      });

      this.readyUnwatch = EventStore.$watch(t => t.ready, (value, _) => {
        this.ready = true;
      });
  }



  check() {
    if (this.dataLoaded && this.localeLoaded)
      EventStore.triggerReady();
  }

  unmounted() {
    if (typeof this.dataUnwatch === 'function')
      this.dataUnwatch();

    if (typeof this.readyUnwatch === 'function')
      this.readyUnwatch();

    if (typeof this.localeUnwatch === 'function')
      this.localeUnwatch();
  }
}
